"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMode = exports.EditContentHelper = void 0;
var Console_helper_1 = require("./Console.helper");
var environment_helper_1 = require("./environment.helper");
var EDIT_RICHTEXT_INLINE = "edit-richTextInline";
exports.EditContentHelper = {
    extractFinalEditContent: function (actionContent, mode, customDocId, customElement) {
        var actionContentFunction = null;
        if (actionContent && Object.keys(actionContent).length > 0) {
            if (mode === EditMode.create) {
                actionContentFunction = actionContent.new || null;
            }
            else if (actionContent.read && actionContent.edit) {
                var regex = /^(.*?)\(’\[(.*?)\]’, ’(.*?)’\)/;
                var contentToBeMatched = mode === EditMode.read ? actionContent.read : actionContent.edit;
                var _a = contentToBeMatched.match(regex) || [], _ = _a[0], functionName = _a[1], params = _a[2], actionText = _a[3];
                var regex1 = /docid=’(.*?)’/;
                var _b = params.match(regex1) || [], __ = _b[0], docid = _b[1];
                var regex2 = /action=’(.*?)’/;
                var _c = params.match(regex2) || [], ___ = _c[0], action = _c[1];
                var regex3 = /dialogPocUri=’(.*?)’/;
                var _d = params.match(regex3) || [], ____ = _d[0], dialogPocUri = _d[1];
                var regex4 = /wcmitemisdraft=’(.*?)’/;
                var _e = params.match(regex4) || [], _____ = _e[0], wcmitemisdraft = _e[1];
                var paramsArray = ["uri=".concat(dialogPocUri)];
                if (customDocId) {
                    var _f = docid
                        ? docid.split(/(\/|%2F)/)
                        : ["com.aptrix.pluto.content.Content", "/"], docidPre = _f[0], _g = _f[1], docidDivider = _g === void 0 ? "/" : _g;
                    paramsArray.push("docid=".concat(docidPre).concat(docidDivider).concat(customDocId));
                }
                else {
                    paramsArray.push("docid=".concat(docid));
                }
                if (mode === EditMode.delete) {
                    paramsArray.push("action=delete");
                }
                else {
                    paramsArray.push("action=".concat(action));
                    if (customElement) {
                        paramsArray.push("element=".concat(customElement));
                    }
                }
                if (wcmitemisdraft) {
                    paramsArray.push("wcmitemisdraft=".concat(wcmitemisdraft));
                }
                var allStringedParams = paramsArray.join("&");
                actionContentFunction = "".concat(functionName, "('?").concat(allStringedParams, "', '").concat(mode, "');");
            }
            else {
                Console_helper_1.ConsoleHelper.error("[extractFinalEditContent] ERROR: ".concat(!actionContent.read ? "actionContent.read" : "actionContent.edit", " is undefined"));
            }
        }
        else {
            Console_helper_1.ConsoleHelper.error("[extractFinalEditContent] ERROR: actionContent is undefined");
        }
        return actionContentFunction;
    },
    triggerEditContent: function (actionContent, mode, id, name) {
        var _a;
        var finalEditContent = this.extractFinalEditContent(actionContent, mode, id, name);
        Console_helper_1.ConsoleHelper.info("[START] Trigger Edit Content: ", finalEditContent);
        if (finalEditContent && environment_helper_1.EnvironmentHelper.isClientSide()) {
            var regex = /^(.*?)\((.*?)\)/;
            var _b = finalEditContent.match(regex) || [], _ = _b[0], originalFunctionName = _b[1], originalParams = _b[2];
            var functionName = originalFunctionName.replace("javascript:", "");
            // TODO - It's not handled params like boolean and numbers
            var params = originalParams
                .split(",")
                .map(function (el) {
                return el.trim().replace(/’/g, "'").replace(/^'/, "").replace(/'$/, "");
            });
            try {
                if (functionName in window &&
                    typeof window[functionName] === "function") {
                    (_a = window)[functionName].apply(_a, params);
                }
                else {
                    throw new Error("There is NOT ".concat(functionName, " in window object"));
                }
            }
            catch (error) {
                Console_helper_1.ConsoleHelper.error("=====[ERROR] Trigger Edit Content: ", finalEditContent, "\n", error, "\n=====");
            }
        }
        else {
            Console_helper_1.ConsoleHelper.error("[ERROR] Trigger Edit Content: ", finalEditContent);
        }
    },
    richTextInlineEvent: function () {
        return EDIT_RICHTEXT_INLINE;
    },
    disableEditContent: function (event, ref, collections) {
        var setPointerEvents = function (pointerEvent) {
            ref.current.style.pointerEvents = pointerEvent;
            collections.forEach(function (collection) {
                var list = Array.from(collection);
                list.forEach(function (div) { return (div.style.pointerEvents = pointerEvent); });
            });
        };
        // Access custom data from the event
        var customData = event === null || event === void 0 ? void 0 : event.detail;
        if (ref && collections.length > 0)
            (customData === null || customData === void 0 ? void 0 : customData.richTextInline)
                ? setPointerEvents("none")
                : setPointerEvents("auto");
        return event === null || event === void 0 ? void 0 : event.detail;
    },
};
var EditMode;
(function (EditMode) {
    EditMode["create"] = "Nuovo";
    EditMode["modify"] = "Modifica";
    EditMode["delete"] = "Elimina";
    EditMode["read"] = "Leggi";
})(EditMode = exports.EditMode || (exports.EditMode = {}));
